import { extractTrpcCode } from "@champ-erp/auth-primitives/web";

import { sessionCouranteProuvee } from "./mutation-session-recovery.js";

function statutHttp(erreur: unknown): number | null {
  if (!erreur || typeof erreur !== "object") return null;
  const statut = (erreur as { meta?: { response?: { status?: unknown } } }).meta?.response?.status;
  return typeof statut === "number" ? statut : null;
}

/** Un refus explicite prime toujours sur une identité encore présente en cache. */
export function refusAccesSession(erreur: unknown): "UNAUTHORIZED" | "FORBIDDEN" | null {
  const code = extractTrpcCode(erreur);
  const statut = statutHttp(erreur);
  if (code === "UNAUTHORIZED" || statut === 401) return "UNAUTHORIZED";
  if (code === "FORBIDDEN" || statut === 403) return "FORBIDDEN";
  return null;
}

export function erreurSessionTemporaire(erreur: unknown): boolean {
  if (!erreur || refusAccesSession(erreur)) return false;
  const code = extractTrpcCode(erreur);
  const statut = statutHttp(erreur);
  if (statut !== null && statut >= 400 && statut < 500 && ![408, 429].includes(statut))
    return false;
  return (
    code === null ||
    [
      "INTERNAL_SERVER_ERROR",
      "BAD_GATEWAY",
      "SERVICE_UNAVAILABLE",
      "GATEWAY_TIMEOUT",
      "TIMEOUT",
      "TOO_MANY_REQUESTS",
    ].includes(code)
  );
}

/**
 * Uniquement le résultat courant de auth.me, jamais un ancien utilisateur
 * mémorisé à part. Une purge de cache ou un refus ferme immédiatement l'accès.
 * Une panne conserve l'identité déjà confirmée, sans affirmer sa revalidation.
 */
export function identiteSessionUtilisable(contexte: { data?: unknown; error?: unknown }): boolean {
  return (
    sessionCouranteProuvee(contexte.data) &&
    (!contexte.error || erreurSessionTemporaire(contexte.error))
  );
}
